<template>
  <div v-if="!isMantenance" id="shipping-amazon" class="panel-body">
    <p class="text-size-20">STOCKCREW倉庫にある商品をAmazon倉庫へ出荷（納品）する依頼を作成することができます</p>
    <div class="mr-t-15 text-warning bg-warning font-bold" style="margin-left: 30px; width: 850px;">
      <span style="padding: 10px;">3営業日以内を目途に出荷されます。</span>
    </div>
    <div class="mr-t-20" style="min-width: 1500px;">
      <div class="flexbox gap-15">
        <svg width="50" height="50">
          <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">1</text>
        </svg>
        <span class="font-bold text-size-16 text-primary">基本情報入力</span>
      </div>
      <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
        <div class="box-delivery-name m-b-md">
          <div class="row">
            <div class="col-md-2 col-lg-1 w-150">
              <div class="delivery-name"><strong>出荷名</strong></div>
            </div>
            <div class="col-md-10 col-lg-7">
              <input type="text" :class="['form-control', shippingName ? '' : 'bg-no-input']" v-model.trim="shippingName">
              <div>※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。</div>
              <div v-if="validateErrors.shippingName.length" class="text-red"><b>{{ validateErrors.shippingName[0]}}</b></div>
            </div>
          </div>
        </div>
        <div class="box-origin-info-default m-b-sm">
          <div class="row">
            <div class="col-md-2 col-lg-1 w-150">
              <div class="m-b-sm"><strong>発送元情報</strong></div>
            </div>
            <div class="col-md-9 col-lg-10">
              STOCKCREW倉庫
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mr-t-20" style="min-width: 1500px;">
      <div class="flexbox gap-15">
        <svg width="50" height="50">
          <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
          <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">2</text>
        </svg>
        <span class="font-bold text-size-16 text-primary">商品情報入力</span>
      </div>
      <div id="product-input" class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
        <fixed-header v-show="isShowFixedHeader" :textBtnRegister="'出荷依頼'" @handleClickAdd="openModalDeliveryProductAdd()" @handleClickRegister="submitValidate()"/>
        <p class="">出荷する商品を選択し、商品情報を入力してください。</p>
        <button type="button" class="btn btn-primary check-maintenance" @click.prevent="openModalDeliveryProductAdd()">商品選択</button>
        <button type="button" class="btn btn-warning check-maintenance" @click.prevent="openModalUpload()">
          <i v-if="isBasicPlan" class="fa fa-lock" aria-hidden="true"></i>
          CSVアップロード
        </button>
        <div v-if="selectedProducts.length" class="table-selected-products">
          <table class="full-width">
            <thead>
              <tr>
                <th class="text-center w-150">出荷する商品</th>
                <th style="min-width: 500px;"></th>
                <th class="text-right w-150">Amazon在庫数</th>
                <th class="text-right w-200">STOCKCREW在庫数</th>
                <th class="w-120">出荷予定数</th>
                <th class="text-center w-100">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(selectedProduct, index) in selectedProducts" :key="index">
                <td class="text-center">
                  <div class="box-selected-product-image w-40">
                    <img :src="selectedProduct.image" alt="" class="selected-product-image img-responsive">
                  </div>
                  <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(selectedProduct.status_str)}`">{{ selectedProduct.status_str }}</div>
                </td>
                <td>
                  <div class="m-b-xs">{{ selectedProduct.itemName }}</div>
                  <div><b>ASIN：</b>{{selectedProduct.asin}} / <b>SKU：</b>{{ selectedProduct.sku }} </div>
                  <div><b>商品ID：</b>{{selectedProduct.itemId}} / <b>商品ラベル：</b>{{ selectedProduct.goodsLabel }}</div>
                </td>
                <td class="text-right">
                  {{ formatNumber(selectedProduct.amazonQuantity) }} 個
                </td>
                <td colspan="2">
                  <tr>
                    <td class="text-right w-200 no-borders no-padding">
                      <span class="">{{ formatNumber(selectedProduct.scQuantity) }} 個</span>
                      <br>
                      <div v-if="selectedProduct.dueDateManageFlg" class="product-bubble-wrapper">
                        <a href="javascript:void(0)" @click="getStockByExpDate($event, selectedProduct)" @mouseleave="closeBubble($event)" class="text--underline">有効期限毎に表示</a>
                        <div v-show="false" class="product-bubble bubble">
                          <div v-if="stockInfo" v-for="(item, index) in stockInfo" :key="index">
                            <span v-if="item.quantity > 0">{{ item.expirationDateDisplay }} : {{ item.quantity }}個</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="no-borders">
                      <input type="text" class="form-control expected-delivery-number text-right mr-l-10" :class="parseInt(selectedProduct.quantity) && parseInt(selectedProduct.quantity) <= parseInt(selectedProduct.scQuantity) ? '' : 'bg-no-input'" v-model="selectedProduct.quantity" @input="selectedProduct.quantity = handleInputQuantity(selectedProduct.quantity)" @blur="updateStorageProducts">
                    </td>
                  </tr>
                  <div v-if="validateErrors.quantity[selectedProduct.itemId] && validateErrors.quantity[selectedProduct.itemId].length" class="text-red text-right"><b>{{ validateErrors.quantity[selectedProduct.itemId][0]}}</b></div>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-delete-selected-product check-maintenance" @click.prevent="deleteDeliverySelectedProduct(selectedProduct)">削除</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center m-b-md m-t-md">
            <button type="button" class="btn btn-primary custom-btn check-maintenance" @click.prevent="submitValidate">
              出荷依頼
              <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div v-else class="empty-products text-center">
          <h3 class="m-b-xl text-center"><strong>商品選択より、出荷する商品を選択してください。</strong></h3>
        </div>
      </div>
    </div>
    <shipping-amazon-product-add
      v-if="openShippingProductAddModal"
      ref="shippingAmazonProductAddModal"
      :iconUrls="iconUrls"
      :selectedProducts="storageSelectedProducts"
      @close="closeModalProductAdd"
      @handleSelectedProduct="handleSelectedProduct"
      @handleSelectedProducts="handleSelectedProducts"
    />
    <modal-alert-get-latest-product
      v-if="showGetLatestProductModal"
      :message="getLatestProductNotiMessage"
      :customBodyClass="`text-center`"
      @close="closeGetLatestProductModal"
      @confirm="confirmGetLatestProductModal"
    />
    <modal-alert
      v-if="showGetLatestProductCompletedModal"
      :message="getLatestProductCompletedMessage"
      :customBodyClass="`text-center`"
      @close="closeGetLatestProductCompletedModal"
    />
    <modal-alert
      v-if="openAlertValidateFailsModal"
      :message="alertValidateFailsMessage"
      :customHide="true"
      @close="closeModalAlertValidateFails"
    />
    <modal-confirm
      v-if="openShippingProductsAddConfirmModal"
      :message="shippingProductsAddConfirmMessage"
      @confirm="shippingProductsAdd"
      @close="closeModalConfirmShippingProductsAdd"
    />
    <modal-alert
      v-if="openAlertProductsAddedModal"
      :message="alertProductsAddedMessage"
      :customHide="true"
      :modalWidth="650"
      @close="closeModalAlertProductsAdded"
    />
    <upgrade-plan-modal
      v-if="isShowUpgradePlanModal"
      @close="closeUpgradePlanModal"
    />
     <upload-csv-modal
      v-if="isShowUploadModal"
      :header="uploadCsvHeader"
      :uploadUrl="'Warehouse/sc/shipping/amazon/product-available/upload'"
      :needProductId="true"
      :settingProductIdOptions="settingProductIdOptions"
      @handleDownloadTemplate="handleDownloadTemplate"
      @handleUploadSuccess="handleUploadSuccess"
      @close="closeUploadModal"
    />
    <modal-alert
      v-if="openUploadedModal"
      :message="uploadedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeUploadedModal"
    />
    <modal-alert
      v-if="openModalAlert"
      :message="alertMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlert"
    />
  </div>
  <maintenance-modal v-else :html="userInfo.acrossDeliveryStopExp" :hasBypassMaintenance="true"  @close="closeMaintenanceModal" @bypassMaintenance="bypassMaintenance" />
</template>

<script>
import { mapGetters } from 'vuex'
import Util from '@/common/utility'
import moment from 'moment'
import ProductService from '@/services/productservice'
import SettingService from '@/services/settingservice'
import ModalAlert from '@/components/ModalAlert'
import ModalAlertGetLatestProduct from '@/view/warehouseAcross/components/ModalAlert'
import ModalConfirm from '@/components/ModalConfirm'
import ShippingAmazonProductAdd from '@/view/warehouseSc/components/ShippingAmazonProductAdd'
import FixedHeader from '@/view/warehouseAcross/components/FixedHeader'
import UpgradePlanModal from '@/view/warehouses/UpgradePlanModal'
import UploadCsvModal from '@/components/UploadCsvModal'
import WarehouseScService from '@/services/warehousescservice'
import MaintenanceModal from '@/view/warehouses/MaintenanceModal'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAlert,
    ModalAlertGetLatestProduct,
    ModalConfirm,
    ShippingAmazonProductAdd,
    FixedHeader,
    UpgradePlanModal,
    UploadCsvModal,
    MaintenanceModal
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loader: null,
      isMantenance: false,
      openModalAlert: false,
      alertMessage: '',
      showGetLatestProductModal: false,
      showGetLatestProductCompletedModal: false,
      openShippingProductsAddConfirmModal: false,
      openAlertProductsAddedModal: false,
      openShippingProductAddModal: false,
      openAlertValidateFailsModal: false,
      isShowFixedHeader: false,
      shippingNo: null,
      shippingName: null,
      validateErrors: {
        shippingName: [],
        quantity: {}
      },
      storageSelectedProducts: [],
      getLatestProductNotiMessage: '商品情報を最新化する必要があります。<br> はじめに最新の商品情報を取得します。',
      getLatestProductCompletedMessage: '商品が最新状態に更新されました。',
      alertValidateFailsMessage: '入力エラーです。<br/>入力内容を確認、修正後にご登録をお願いします。',
      shippingProductsAddConfirmMessage: '出荷情報を登録します。 よろしいですか？',
      stockInfo: [],
      isShowUpgradePlanModal: false,
      isShowUploadModal: false,
      settingProductIdOptions: [
        {
          value: 'ITEMID',
          text: '商品ID'
        },
        {
          value: 'FNSKU',
          text: '商品ラベル(FNSKU)'
        },
        {
          value: 'ASIN',
          text: 'ASIN'
        },
        {
          value: 'SKU',
          text: 'SKU'
        }
      ],
      notRefProducts: [],
      totalUpload: 0,
      invalidUpload: [],
      duplicateUpload: [],
      duplicateStockUpload: [],
      openUploadedModal: false
    }
  },
  created () {
    const query = this.$route.query
    if (query && query.shippingId && query.shippingNo) {
      this.getShippingDetail(query.shippingNo, query.shippingId)
    } else {
      this.getShippingSelectedProducts()
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      iconUrls: 'getWareHouseIcons'
    }),
    storageSelectedProductsName () {
      return `${this.userInfo.sellerId}-ScShipToAmazonSelectedProducts`
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    },
    selectedProducts () {
      return this.storageSelectedProducts
    },
    alertProductsAddedMessage () {
      return `
        出荷情報を受付けました。 <br>
        出荷管理番号： ${this.shippingNo} <br> <br>
        <div>
          STOCKCREW倉庫からAmazon倉庫への出荷（納品）は自動的に行われますが<br>
          出荷プロセスにおいてエラーとなる可能性があります。<br> <br>
          詳しくは、別途ご送付するメールをご参照いただくか、 <br>
          または出荷状況照会画面よりご確認をお願いします。
        </div>
      `
    },
    uploadCsvHeader () {
      return `<div class="flexbox">
        <img src="${this.$store.getters.getWareHouseIcons.salmonSc}" class="w-20"> STOCKCREW倉庫 → <img src="${this.$store.getters.getWareHouseIcons.Amazon}" class="w-20"> Amazon倉庫へ納品する商品・数量をアップロードしてください
      </div>
      <span style="color: red; font-size: 14px;">「テンプレートをダウンロード」よりテンプレートをダウンロード・編集の上、ご登録ください。</span>
      `
    },
    uploadedMessage () {
      const successUpload = Math.max(0, this.totalUpload - this.invalidUpload.length - this.duplicateUpload.length - this.duplicateStockUpload.length)
      let html = `<p><b>${successUpload}件/${this.totalUpload}件 商品の追加が成功しました</b></p>`

      if (this.invalidUpload.length > 0) {
        html += `<div class="text-danger"><b>エラー${this.invalidUpload.length}件 商品が存在しません</b></div>`
        this.invalidUpload.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      if (this.duplicateUpload.length > 0) {
        html += '<br>'
        html += `<div class="text-danger"><b>エラー${this.duplicateUpload.length}件 商品が重複しています</b></div>`
        this.duplicateUpload.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      if (this.duplicateStockUpload.length > 0) {
        html += '<br>'
        html += `<div class="text-danger"><b>エラー${this.duplicateStockUpload.length}件 在庫ありの商品が複数あるため特定できません</b></div>`
        this.duplicateStockUpload.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      return html
    },
    notRefProductsMessage () {
      let html = '<p>以下の商品は存在しないため、複製対象から除外します</p>'

      if (this.notRefProducts.length > 0) {
        html += '<ul>'
        this.notRefProducts.forEach(product => {
          html += '<li>'
          if (product.itemName) {
            html += `<div><b>商品名:</b> ${product.itemName}</div>`
          }
          html += `<div><b>ASIN:</b> ${product.asin} <b>FNSKU:</b> ${product.fnsku}</div>`
          html += '</li>'
        })
      }
      html += '</ul>'
      return html
    }
  },
  methods: {
    bypassMaintenance () {
      $('#maintenance-modal').modal('hide')
      this.isMantenance = false
    },
    closeMaintenanceModal () {
      $('#maintenance-modal').modal('hide')
      this.$router.push('/warehouse-sc/shipping/shipping-status-inquiry')
    },
    closeModalAlert () {
      $('#myModal').modal('hide')
      this.alertMessage = ''
      this.openModalAlert = false
    },
    closeGetLatestProductModal () {
      $('#myModal').modal('hide')
      this.showGetLatestProductModal = false
    },
    confirmGetLatestProductModal () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_update_inventory_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.closeGetLatestProductModal()
      this.getLatestProduct()
    },
    closeGetLatestProductCompletedModal () {
      $('#myModal').modal('hide')
      this.showGetLatestProductCompletedModal = false
    },
    closeModalProductAdd () {
      $('#shipping-product-add-modal').modal('hide')
      this.openShippingProductAddModal = false
    },
    openModalAlertValidateFails () {
      this.openAlertValidateFailsModal = true
    },
    closeModalAlertValidateFails () {
      $('#myModal').modal('hide')
      this.openAlertValidateFailsModal = false
    },
    openModalConfirmShippingProductsAdd () {
      if (this.isValidateFails) return
      this.openShippingProductsAddConfirmModal = true
    },
    closeModalConfirmShippingProductsAdd () {
      $('#confirm-alert').modal('hide')
      this.openShippingProductsAddConfirmModal = false
    },
    openModalAlertProductsAdded () {
      this.openAlertProductsAddedModal = true
    },
    closeModalAlertProductsAdded () {
      $('#myModal').modal('hide')
      this.openAlertProductsAddedModal = false
      this.shippingName = null
      this.shippingNo = null
      this.$router.push({
        name: 'Warehouse sc',
        params: {
          tab: 'shipping',
          subTab: 'shipping-status-inquiry'
        }
      })
    },
    async getShippingDetail (shippingNo, shippingId) {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: shippingNo,
        shippingId: shippingId
      }
      await WarehouseScService.getAmazonShippingDetail(params)
        .then((response) => {
          this.shippingName = response.data.shippingName
          this.clearStorage()
          if (response.data.shippingGoods && response.data.shippingGoods.length > 0) {
            localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(response.data.shippingGoods))
            this.storageSelectedProducts = response.data.shippingGoods
          }
          if (response.data.notRefProducts && response.data.notRefProducts.length > 0) {
            this.notRefProducts = response.data.notRefProducts
            this.alertMessage = this.notRefProductsMessage
            this.openModalAlert = true
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    getShippingSelectedProducts () {
      this.storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageSelectedProductsName) || '[]')
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    deleteDeliverySelectedProduct (product) {
      this.storageSelectedProducts = this.storageSelectedProducts.filter(item => item.itemId !== product.itemId)
      localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(this.storageSelectedProducts))
    },
    handleSelectedProduct (product) {
      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageSelectedProductsName) || '[]')
      let selectedProducts = [...storageSelectedProducts, product]
      localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    handleSelectedProducts (products) {
      let storageSelectedProducts = JSON.parse(localStorage.getItem(this.storageSelectedProductsName) || '[]')
      let selectedProducts = [...storageSelectedProducts, ...products]
      localStorage.setItem(this.storageSelectedProductsName, JSON.stringify(selectedProducts))
      this.storageSelectedProducts = selectedProducts
    },
    updateStorageProducts () {
      let selectedProducts = this.storageSelectedProducts
      localStorage.removeItem(this.storageSelectedProductsName)
      this.storageSelectedProducts = []
      this.handleSelectedProducts(selectedProducts)
    },
    getAvailabilityDate (product) {
      let availabilityDate = ''
      let expirationDate = product.expirationDate
      if (!expirationDate) {
        return availabilityDate
      }
      let minusDate = product.settingShippingNgPeriodValue

      if (product.hasYamatoOffer && product.yamatoShippingNgPeriod) {
        minusDate = product.yamatoShippingNgPeriod
      }

      let newDate = new Date(expirationDate)
      newDate.setDate(newDate.getDate() - minusDate)
      availabilityDate = moment(newDate).format('YYYY/MM/DD')

      return availabilityDate
    },
    checkLatestProductDate () {
      if (this.userInfo.getLatestProductsDate === null) {
        return true
      }
      const minusUpdateLatest = 120
      let getLatestProductsDate = new Date(this.userInfo.getLatestProductsDate)
      getLatestProductsDate.setTime(getLatestProductsDate.getTime() + minusUpdateLatest * 60 * 1000)
      let now = new Date()
      return now.getTime() >= getLatestProductsDate.getTime()
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    openModalDeliveryProductAdd () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_select_product_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (this.checkLatestProductDate()) {
        this.showGetLatestProductModal = true
      } else {
        this.openShippingProductAddModal = true
      }
    },

    async getLatestProduct () {
      this.loader = this.$loading.show()
      await ProductService.getLatestProducts()
        .then((response) => {
          this.clearStorage()
          this.getSellerInfo()
          this.loader && this.loader.hide()
          this.showGetLatestProductCompletedModal = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
    },
    clearStorage () {
      localStorage.removeItem(this.storageSelectedProductsName)
      this.storageSelectedProducts = []
    },
    async submitValidate () {
      this.loader = this.$loading.show()
      let params = {
        shippingGoods: this.storageSelectedProducts
      }
      await WarehouseScService.getAmazonShippingStockInfo(params)
        .then((response) => {
          this.storageSelectedProducts = response.data
          this.validateInput()
        })
        .catch((error) => {
          if (error.header && error.header.resultCode === '4991') {
            const skus = error.records.data.skus.map((sku) => `<li>${sku}</li>`).join('')
            error = `
            <b class="text-red text-size-20">
              <i class='fa fa-exclamation-triangle mr-r-10' aria-hidden='true'></i>
              Amazonにて梱包設定が必要な商品があります。
            </b>
            <br/>
            <br/>
            <b>セラーセントラルにて梱包設定後に出荷依頼をお願いします。</b>
            <br/>
            <a href="https://www.canva.com/design/DAGXEmb3jT4/cFYyKV6ZztEGuq8nYkhJtA/view?utm_content=DAGXEmb3jT4&utm_campaign=designshare&utm_medium=link&utm_source=editor" class="text--underline" target="_blank">詳しくはこちらをご確認ください</a>
            <br/>
            <br/>
            対象のSKU
            <ul>
              ${skus}
            </ul>
            `
            this.$events.fire('handleError', error, 600)
          } else if (error.header && error.header.resultCode === '4992') {
            const skus = error.records.data.skus.map((sku) => `<li>${sku}</li>`).join('')
            error = `
            <b class="text-red text-size-20">
              <i class='fa fa-exclamation-triangle mr-r-10' aria-hidden='true'></i>
              以下のSKUにてエラーが発生しました。
            </b>
            <br/>
            <br/>
            <b>Amazonへ納品できない商品の可能性があります。</b>
            <br/>
            <b>セラーセントラルにて商品の状態をご確認ください。</b>
            <br/>
            <br/>
            対象のSKU
            <ul>
              ${skus}
            </ul>
            `
            this.$events.fire('handleError', error, 600)
          } else {
            this.$events.fire('handleError', error)
          }
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    validateInput () {
      let required = '※必ず入力してください'
      let validateMin = '※1以上の数値を入力してください'
      let validateMax = '※STOCKCREW在庫数以内で入力してください'
      let expDate = '※有効期限毎の在庫数内で入力してください'
      this.isValidateFails = false
      if (!this.shippingName || !this.shippingName.trim()) {
        this.validateErrors.shippingName.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.shippingName = []
      }
      this.storageSelectedProducts.forEach((product) => {
        let quantity = parseInt(product.quantity)
        let itemId = product.itemId
        this.validateErrors.quantity[itemId] = []
        if (isNaN(quantity)) {
          this.validateErrors.quantity[itemId][0] = required
          this.isValidateFails = true
        } else if (quantity === 0) {
          this.validateErrors.quantity[itemId][0] = validateMin
          this.isValidateFails = true
        } else if (!product.dueDateManageFlg && quantity > product.scQuantity) {
          this.validateErrors.quantity[itemId][0] = validateMax
          this.isValidateFails = true
        } else if (product.dueDateManageFlg && product.stockInfo.length) {
          let mapQuantity = product.stockInfo.map((value) => value['quantity'])
          let maxInStock = Math.max(...mapQuantity)
          if (quantity > maxInStock) {
            this.validateErrors.quantity[itemId][0] = expDate
            this.isValidateFails = true
          }
        } else {
          delete this.validateErrors.quantity[itemId]
        }
      })
      this.updateStorageProducts()

      if (this.isValidateFails) {
        this.openModalAlertValidateFails()
      } else {
        this.openModalConfirmShippingProductsAdd()
      }
    },
    shippingProductsAdd () {
      if (this.isValidateFails) return

      this.loader = this.$loading.show()
      let params = {
        shippingGoods: this.storageSelectedProducts,
        shippingName: this.shippingName
      }
      WarehouseScService.registerAmazonShipping(params)
        .then((response) => {
          this.closeModalConfirmShippingProductsAdd()
          this.shippingNo = response.data.shippingNo
          this.openModalAlertProductsAdded()
          this.clearStorage()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          let logParams = {
            name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_request_shipping_btn,
            properties: {
              shippingNo: this.shippingNo
            }
          }
          EventService.postTrackLog(logParams)
          this.loader && this.loader.hide()
        })
    },
    getStockByExpDate (event, product) {
      if (!product.dueDateManageFlg) {
        return false
      }

      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_display_by_exp_date_link,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      let params = {
        itemId: product.itemId
      }
      WarehouseScService.getStockByExpDate(params)
        .then((response) => {
          this.stockInfo = response.data
          $(event.target).siblings('.bubble').show()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    closeBubble (event) {
      $(event.target).siblings('.bubble').hide()
    },
    handleScroll () {
      const fixedHeader = document.getElementById('product-input')
      const initialOffset = fixedHeader.getBoundingClientRect().top + window.scrollY
      this.isShowFixedHeader = window.scrollY >= initialOffset
    },
    handleInputQuantity (value) {
      return value.replace(/[^0-9]/g, '').replace(/^0+/, '')
    },
    openModalUpload () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_upload_by_csv,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (this.isBasicPlan) {
        this.isShowUpgradePlanModal = true
        return
      }

      if (this.checkLatestProductDate()) {
        this.showGetLatestProductModal = true
      } else {
        this.isShowUploadModal = true
      }
    },
    closeUpgradePlanModal () {
      this.isShowUpgradePlanModal = false
      $('#upgrade-plan-modal').modal('hide')
    },
    closeUploadModal () {
      this.isShowUploadModal = false
      $('#upload-csv-modal').modal('hide')
    },
    closeUploadedModal () {
      this.openUploadedModal = false
      $('#myModal').modal('hide')
    },
    handleDownloadTemplate () {
      let logParams = {
        name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.click_download_template,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      WarehouseScService.downloadProductsCsvTemplate({}, '出荷テンプレート.csv')
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    },
    handleUploadSuccess (response) {
      this.clearStorage()
      const data = response.records.data
      this.totalUpload = data.total
      this.invalidUpload = data.invalid
      this.duplicateUpload = data.duplicate
      this.duplicateStockUpload = data.duplicateStocks
      this.handleSelectedProducts(data.products)
      this.closeUploadModal()
      this.openUploadedModal = true
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.shipping_tab.amazon_shipping.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    window.addEventListener('scroll', this.handleScroll)
  },
  unmouted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped>
.step-rectangle {
  border: 2px solid #008cc6;
  border-radius: 8px;
  padding: 5px;
  width: 350px;
  height: 70px;
}
.text-primary {
  color: #008cc6;
}
.table-selected-products {
  margin-top: 10px;
  /* overflow: auto; */
  padding: 0
}
.table-selected-products table {
  border: 1px solid #ccc
}
.table-selected-products th, .table-selected-products td{
  padding: 5px 10px;
  min-width: 120px;
  height: auto;
  border-bottom: 1px solid #ccc;
}
.table-selected-products th {
  color: #595959;
  background-color: #deebf7;
}
.td-vertical-top {
  vertical-align: top;
}
#shipping-amazon {
  overflow: auto;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.bubble {
  position: absolute;
  top: 35px;
  width: 200px;
  background: #f2f7fc;
  margin: 0 auto;
  border: 2px solid #008cc6;
  padding: 5px 10px;
}
.bubble:before {
    border-width: 0 20px 12px 20px;
    top: -12px;
    left: 50%;
}
.bubble:after {
    border-width: 0 20px 12px 20px;
    top: -10px;
    left: 50%;
}
.product-bubble::before {
  border-color: #008cc6 transparent;
}
.text-warning {
  background-color: #fff2cc;
}
.bg-warning {
  color: #843c0b;
}
.custom-btn {
  font-size: 20px;
  padding: 10px 50px;
  border-radius: 8px;
  background-color: #0070c0;
}
</style>
<style>
#shipping-amazon .bg-no-input {
  background-color: #fdefef !important;
}
#shipping-amazon .row {
  margin-left: -15px;
  margin-right: -15px;
}
#shipping-amazon .mx-datepicker {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/AmazonShipping.vue